<mat-card>
  <mat-card-header>
    <mat-card-title-group>
      <mat-card-title>Évaluations</mat-card-title>
      <div mat-card-img>
        <button class="btn btn-outline-primary btn-sm" (click)="createAssessment()">
          <span class="material-symbols-outlined pt-1">add</span>
        </button>
      </div>
    </mat-card-title-group>
  </mat-card-header>
  <mat-card-content>
    @if (candidate.exams.length !== 0) {
    <div class="table-responsive">
      <table class="table table-striped table-hover mt-2" aria-label="candidate-details-page">
        <thead>
          <tr>
            <th scope="col">Description</th>
            <th scope="col">Statut</th>
            <th scope="col">Temps passé</th>
            <th scope="col" class="action">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (exam of candidate.exams.slice(currentPage[0], currentPage[pageSize - 1] + 1); track exam; let i =
          $index) {
          <tr class="table-row">
            <td (click)="navigateToExam(exam)">
              <strong>
                {{ exam.assessment.name }}
              </strong>
              @if (exam.assessment.isCertifying) {
              <syn-certified-assessment-icon />
              }
            </td>
            <td (click)="navigateToExam(exam)">
              <syn-status-chip [examStatus]="exam.status" />
            </td>
            <td (click)="navigateToExam(exam)">{{ exam.timeSpent | chrono : true }}</td>
            <td>
              <button class="btn btn-outline-danger btn-sm" title="" (click)="removeExam(exam.uuid)">
                <span class="material-symbols-outlined pt-1"> delete </span>
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
      <ul class="pagination justify-content-center">
        <li class="page-item page-point">
          <a
            [className]="pageIndex > 0 ? 'page-link' : 'page-link disabled'"
            (click)="setCurrentPage(-1, candidate.exams.length)"
            title="page backward">
            <span class="material-symbols-outlined">first_page</span>
          </a>
        </li>
        <li class="page-item">
          <a class="page-link text-underline-hover current-page">{{ pageIndex + 1 }}</a>
        </li>
        <li class="page-item page-point">
          <a
            [className]="candidate.exams.length > (pageIndex + 1) * this.pageSize ? 'page-link ' : 'page-link disabled'"
            (click)="setCurrentPage(1, candidate.exams.length)"
            title="page forward">
            <span class="material-symbols-outlined">last_page</span>
          </a>
        </li>
      </ul>
    </div>
    } @else {
    <syn-empty-page message="Ce candidat n'a pas d'évaluation" />
    }
  </mat-card-content>
</mat-card>
